<template>
  <div class="w-100">
    <b-col>
      <slot></slot>
      <div class="d-flex justify-content-between align-items-center w-100 mt-2">
        <div>{{ createdAt | formatDate('Do MMMM YYYY, HH:mm') }}</div>
        <div><strong>{{ points }}</strong> points awarded</div>
      </div>
      <div v-if="note" class="mt-2">
        <small>{{ note }}</small>
      </div>
    </b-col>
  </div>
</template>

<script>
import { formatDate } from '@src/filters';

export default {
  props: {
    createdAt: {
      default: null,
    },
    points: {
      default: null,
    },
    note: {
      default: null,
    },
  },
  computed: {
    formatDate: () => formatDate,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/campaign-admin/CampaignHistoryBlockLayout.vue